'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _localeProvider = require('@alicd/next/lib/locale-provider');

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _calendar = require('./view/calendar');

var _calendar2 = _interopRequireDefault(_calendar);

var _datePickerPanel = require('./view/date-picker-panel');

var _datePickerPanel2 = _interopRequireDefault(_datePickerPanel);

var _rangePickerPanel = require('./view/range-picker-panel');

var _rangePickerPanel2 = _interopRequireDefault(_rangePickerPanel);

var _timePickerPanel = require('./view/time-picker-panel');

var _timePickerPanel2 = _interopRequireDefault(_timePickerPanel);

var _locale = require('./locale');

var _locale2 = _interopRequireDefault(_locale);

var _datePicker = require('./view/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _locale3 = require('@alicd/next/lib/_components/@alicd/next-date-picker/lib/locale');

var _locale4 = _interopRequireDefault(_locale3);

var _locale5 = require('@alicd/next/lib/_components/@alicd/next-time-picker/lib/locale');

var _locale6 = _interopRequireDefault(_locale5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_calendar2.default.LOCALE = _locale2.default;
_datePickerPanel2.default.LOCALE = _locale2.default;
_rangePickerPanel2.default.LOCALE = _locale2.default;

_calendar2.default.DatePickerPanel = _datePickerPanel2.default;
_calendar2.default.RangePickerPanel = _rangePickerPanel2.default;
_calendar2.default.TimePickerPanel = (0, _localeProvider2.default)(_timePickerPanel2.default);
_calendar2.default.TimePickerPanel.LOCALE = _locale6.default;
_calendar2.default.DatePicker = (0, _localeProvider2.default)(_datePicker2.default);
_calendar2.default.DatePicker.LOCALE = _locale4.default;

exports.default = _calendar2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-calendar-ex@0.0.4@@alicd/crui-calendar-ex/lib/index.js
// module id = 265
// module chunks = 0